import { render, staticRenderFns } from "./WhatsAppOnboarding.vue?vue&type=template&id=648f939e&scoped=true"
import script from "./WhatsAppOnboarding.vue?vue&type=script&lang=js"
export * from "./WhatsAppOnboarding.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppOnboarding.vue?vue&type=style&index=0&id=648f939e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f939e",
  null
  
)

export default component.exports